import { Box, Typography } from '@mui/material';
import React from 'react';
import { ContainerHeader } from './header.styled';
import { LogoSmall } from '@components/Logo';
import useUser from '@authentication/hooks/useUser';

function Header() {
  const { pageTitle } = useUser();

  return (
    <ContainerHeader>
      <LogoSmall />

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <Typography
          sx={{
            color: '#EDC2E2',
            // textAlign: 'right',
            // fontFeatureSettings: "'clig' off, 'liga' off",
            fontFamily: 'Inter',
            fontSize: '20px',
            fontStyle: 'normal',
            fontWeight: '700',
            lineHeight: '36px',
            // marginRight: 'auto',
            // marginLeft: 'auto',
          }}
        >
          {pageTitle}
        </Typography>
      </Box>
      <div
        style={{
          width: '200px',
          height: '38px',
          background: 'transparent',
        }}
      />
    </ContainerHeader>
  );
}

export default Header;
